'use client';

import { useState } from 'react';
import Link from 'next/link';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';

// ============================================================
// STATIC DATA — Replace with DB fetch later
// ============================================================
const mockLeaseAgreements = [
    {
        id: 'LA-001',
        lessorName: 'Murugan Enterprises Pvt Ltd',
        lessorPhone: '9876543210',
        lessorEmail: 'murugan.ent@gmail.com',
        lessorAddress: '12, Anna Salai, Teynampet, Chennai - 600018',
        lessorPAN: 'AABCM1234F',
        lesseeName: 'TechNova Solutions LLP',
        lesseePhone: '9123456789',
        lesseeEmail: 'admin@technova.in',
        lesseeAddress: '45, Greams Road, Chennai - 600006',
        lesseeIdProofType: 'Company Registration',
        lesseeIdProofNumber: 'U72200TN2020PTC134567',
        lesseePAN: 'AABFT5678G',
        propertyAddress: 'Ground Floor, Murugan Towers, Plot No. 15, Industrial Estate, Guindy, Chennai - 600032',
        propertyType: 'Commercial Space',
        propertyArea: '3500',
        surveyNumber: 'S.No. 45/2A',
        leaseDurationYears: '5',
        leaseStartDate: '2024-04-01',
        leaseEndDate: '2029-03-31',
        annualRent: '1800000',
        monthlyRent: '150000',
        advanceAmount: '1500000',
        securityDeposit: '900000',
        escalationRate: '10',
        escalationFrequency: 'Annual',
        rentPaymentDueDate: '5',
        renewalOption: 'Yes, with mutual consent for additional 5 years',
        permittedUse: 'IT / Software Development Office',
        sublettingAllowed: 'No',
        stampDutyPaidBy: 'Shared Equally',
        stampDutyAmount: '125000',
        registrationNumber: 'REG/CHN/2024/04567',
        registrationDate: '2024-03-25',
        registeredAt: 'Sub-Registrar Office, Guindy',
        witness1Name: 'Karthikeyan R',
        witness1Phone: '9870001111',
        witness1Address: 'No.5, Ashok Nagar, Chennai - 600083',
        witness2Name: 'Bharathi S',
        witness2Phone: '9870002222',
        witness2Address: 'No.12, Adyar, Chennai - 600020',
        terminationClause: 'Either party may terminate with 6 months written notice. Early termination penalty of 3 months rent applies within lock-in period.',
        specialConditions: 'Lessee shall not make structural modifications without written consent. Lessor shall provide 24/7 power backup. Common area maintenance included in rent.',
        status: 'Active',
        createdAt: '2024-03-20',
    },
    {
        id: 'LA-002',
        lessorName: 'Lakshmi Narayanan Trust',
        lessorPhone: '9988776655',
        lessorEmail: 'lakshmi.trust@gmail.com',
        lessorAddress: '78, Cathedral Road, Gopalapuram, Chennai - 600086',
        lessorPAN: 'AALTL9876H',
        lesseeName: 'Green Valley Clinic',
        lesseePhone: '9876501234',
        lesseeEmail: 'greenvalley.clinic@gmail.com',
        lesseeAddress: '23, Nungambakkam High Road, Chennai - 600034',
        lesseeIdProofType: 'Partnership Deed',
        lesseeIdProofNumber: 'PD/TN/2023/08901',
        lesseePAN: 'AABFG2345K',
        propertyAddress: '1st & 2nd Floor, Narayana Complex, No. 56, TTK Road, Alwarpet, Chennai - 600018',
        propertyType: 'Medical/Clinic',
        propertyArea: '2200',
        surveyNumber: 'S.No. 112/3B',
        leaseDurationYears: '10',
        leaseStartDate: '2023-01-01',
        leaseEndDate: '2032-12-31',
        annualRent: '2400000',
        monthlyRent: '200000',
        advanceAmount: '2000000',
        securityDeposit: '1200000',
        escalationRate: '8',
        escalationFrequency: 'Every 3 Years',
        rentPaymentDueDate: '1',
        renewalOption: 'Auto-renewal for 5 years unless 12 months prior notice given',
        permittedUse: 'Medical Clinic / Diagnostic Center',
        sublettingAllowed: 'Partial (with consent)',
        stampDutyPaidBy: 'Lessee',
        stampDutyAmount: '350000',
        registrationNumber: 'REG/CHN/2023/01234',
        registrationDate: '2022-12-15',
        registeredAt: 'Sub-Registrar Office, Mylapore',
        witness1Name: 'Venkatesh M',
        witness1Phone: '9870003333',
        witness1Address: 'No.8, Velachery, Chennai - 600042',
        witness2Name: 'Sundari P',
        witness2Phone: '9870004444',
        witness2Address: 'No.20, Besant Nagar, Chennai - 600090',
        terminationClause: 'Termination only after lock-in period of 3 years. 12 months written notice required. Compensation of 6 months rent for early exit.',
        specialConditions: 'Biomedical waste disposal responsibility of lessee. Fire safety compliance mandatory. Signage rights on building facade included.',
        status: 'Active',
        createdAt: '2022-12-10',
    },
    {
        id: 'LA-003',
        lessorName: 'Selvam & Sons Properties',
        lessorPhone: '9871234567',
        lessorEmail: 'selvam.props@gmail.com',
        lessorAddress: '56, Mount Road, Saidapet, Chennai - 600015',
        lessorPAN: 'AASPS4567L',
        lesseeName: 'Metro Warehouse Solutions',
        lesseePhone: '9001234567',
        lesseeEmail: 'metro.warehouse@gmail.com',
        lesseeAddress: '89, Industrial Area, Ambattur, Chennai - 600058',
        lesseeIdProofType: 'Company Registration',
        lesseeIdProofNumber: 'U52100TN2019PTC128901',
        lesseePAN: 'AACFM7890P',
        propertyAddress: 'Plot No.8, SIDCO Industrial Estate, Phase-II, Ambattur, Chennai - 600098',
        propertyType: 'Warehouse/Godown',
        propertyArea: '8000',
        surveyNumber: 'S.No. 234/1',
        leaseDurationYears: '15',
        leaseStartDate: '2020-06-01',
        leaseEndDate: '2035-05-31',
        annualRent: '3600000',
        monthlyRent: '300000',
        advanceAmount: '3000000',
        securityDeposit: '1800000',
        escalationRate: '12',
        escalationFrequency: 'Every 3 Years',
        rentPaymentDueDate: '10',
        renewalOption: 'Renewable for additional 10 years with revised terms',
        permittedUse: 'Warehouse / Storage / Distribution Center',
        sublettingAllowed: 'No',
        stampDutyPaidBy: 'Lessor',
        stampDutyAmount: '750000',
        registrationNumber: 'REG/CHN/2020/06789',
        registrationDate: '2020-05-20',
        registeredAt: 'Sub-Registrar Office, Ambattur',
        witness1Name: 'Ravi Kumar A',
        witness1Phone: '9870005555',
        witness1Address: 'No.15, Mogappair, Chennai - 600037',
        witness2Name: 'Jayalakshmi D',
        witness2Phone: '9870006666',
        witness2Address: 'No.30, Anna Nagar, Chennai - 600040',
        terminationClause: 'Lock-in period of 5 years. Post lock-in, 6 months notice required. Penalty of 12 months rent for termination during lock-in.',
        specialConditions: 'Structural modifications for racking systems allowed. Heavy vehicle access road maintenance shared. 24-hour security provided by lessor.',
        status: 'Active',
        createdAt: '2020-05-15',
    },
    {
        id: 'LA-004',
        lessorName: 'Parvathi Ammal Charitable Trust',
        lessorPhone: '9845612378',
        lessorEmail: 'parvathi.trust@gmail.com',
        lessorAddress: '34, Poonamallee High Road, Kilpauk, Chennai - 600010',
        lessorPAN: 'AATPP6789Q',
        lesseeName: 'Sunrise Academy',
        lesseePhone: '9786543210',
        lesseeEmail: 'sunrise.academy@gmail.com',
        lesseeAddress: '67, Royapettah, Chennai - 600014',
        lesseeIdProofType: 'Trust Registration',
        lesseeIdProofNumber: 'TR/TN/2018/05678',
        lesseePAN: 'AABTS3456R',
        propertyAddress: 'Survey No. 78, Pallikaranai Main Road, Near Velachery Junction, Chennai - 600100',
        propertyType: 'Educational Institution',
        propertyArea: '12000',
        surveyNumber: 'S.No. 78/1, 78/2',
        leaseDurationYears: '20',
        leaseStartDate: '2019-06-01',
        leaseEndDate: '2039-05-31',
        annualRent: '4800000',
        monthlyRent: '400000',
        advanceAmount: '5000000',
        securityDeposit: '2400000',
        escalationRate: '5',
        escalationFrequency: 'Every 5 Years',
        rentPaymentDueDate: '1',
        renewalOption: 'Auto-renew for 10 years unless 24 months prior notice',
        permittedUse: 'Educational Institution / School / Coaching Center',
        sublettingAllowed: 'No',
        stampDutyPaidBy: 'Shared Equally',
        stampDutyAmount: '1200000',
        registrationNumber: 'REG/CHN/2019/03456',
        registrationDate: '2019-05-15',
        registeredAt: 'Sub-Registrar Office, Sholinganallur',
        witness1Name: 'Arjun S',
        witness1Phone: '9870007777',
        witness1Address: 'No.22, Chromepet, Chennai - 600044',
        witness2Name: 'Meenakshi K',
        witness2Phone: '9870008888',
        witness2Address: 'No.45, Tambaram, Chennai - 600045',
        terminationClause: 'Lock-in of 10 years mandatory. Post lock-in, 24 months written notice. Lessee shall restore premises to original condition.',
        specialConditions: 'Construction of permanent structures allowed with prior approval. Playground and parking facilities included. Property tax borne by lessor.',
        status: 'Active',
        createdAt: '2019-05-10',
    },
    {
        id: 'LA-005',
        lessorName: 'Rajan Family Holdings',
        lessorPhone: '9812345678',
        lessorEmail: 'rajan.holdings@gmail.com',
        lessorAddress: '90, ECR Road, Injambakkam, Chennai - 600115',
        lessorPAN: 'AAKPR8901S',
        lesseeName: 'Coastal Resorts Pvt Ltd',
        lesseePhone: '9898989898',
        lesseeEmail: 'coastal.resorts@gmail.com',
        lesseeAddress: '15, Marina Beach Road, Chennai - 600001',
        lesseeIdProofType: 'Company Registration',
        lesseeIdProofNumber: 'U55101TN2022PTC145678',
        lesseePAN: 'AACFC1234T',
        propertyAddress: 'Beach Plot No.3, ECR, Neelankarai, Chennai - 600041',
        propertyType: 'Hospitality/Resort',
        propertyArea: '25000',
        surveyNumber: 'S.No. 345/1A',
        leaseDurationYears: '3',
        leaseStartDate: '2022-01-01',
        leaseEndDate: '2024-12-31',
        annualRent: '6000000',
        monthlyRent: '500000',
        advanceAmount: '5000000',
        securityDeposit: '3000000',
        escalationRate: '15',
        escalationFrequency: 'Annual',
        rentPaymentDueDate: '5',
        renewalOption: 'Renewal subject to fresh negotiation',
        permittedUse: 'Resort / Hospitality / Event Venue',
        sublettingAllowed: 'Partial (with consent)',
        stampDutyPaidBy: 'Lessee',
        stampDutyAmount: '500000',
        registrationNumber: 'REG/CHN/2022/07890',
        registrationDate: '2021-12-20',
        registeredAt: 'Sub-Registrar Office, Sholinganallur',
        witness1Name: 'Dinesh R',
        witness1Phone: '9870009999',
        witness1Address: 'No.55, Palavakkam, Chennai - 600041',
        witness2Name: 'Saranya V',
        witness2Phone: '9870000011',
        witness2Address: 'No.8, Thiruvanmiyur, Chennai - 600041',
        terminationClause: 'Either party may terminate with 3 months notice after first year. No penalty post lock-in of 1 year.',
        specialConditions: 'Temporary structures and landscaping allowed. Lessee responsible for all statutory permissions. Revenue sharing of 2% on events above ₹10 lakhs.',
        status: 'Expired',
        createdAt: '2021-12-15',
    },
];

const propertyTypes = [
    'Commercial Space', 'Retail/Showroom', 'Warehouse/Godown', 'Industrial',
    'Office Space', 'Medical/Clinic', 'Educational Institution', 'Hospitality/Resort',
    'Agricultural Land', 'Residential'
];
const idProofTypes = ['Company Registration', 'Partnership Deed', 'Trust Registration', 'Aadhaar', 'PAN', 'Passport', 'Driving License'];
const escalationFrequencies = ['Annual', 'Every 2 Years', 'Every 3 Years', 'Every 5 Years', 'No Escalation'];
const stampDutyPaidByOptions = ['Lessor', 'Lessee', 'Shared Equally'];
const sublettingOptions = ['No', 'Yes', 'Partial (with consent)'];
const statusOptions = ['Active', 'Expired', 'Pending', 'Terminated', 'Under Renewal'];

const emptyForm = {
    lessorName: '', lessorPhone: '', lessorEmail: '', lessorAddress: '', lessorPAN: '',
    lesseeName: '', lesseePhone: '', lesseeEmail: '', lesseeAddress: '',
    lesseeIdProofType: 'Company Registration', lesseeIdProofNumber: '', lesseePAN: '',
    propertyAddress: '', propertyType: 'Commercial Space', propertyArea: '', surveyNumber: '',
    leaseDurationYears: '', leaseStartDate: '', leaseEndDate: '',
    annualRent: '', monthlyRent: '', advanceAmount: '', securityDeposit: '',
    escalationRate: '', escalationFrequency: 'Annual', rentPaymentDueDate: '',
    renewalOption: '', permittedUse: '', sublettingAllowed: 'No',
    stampDutyPaidBy: 'Shared Equally', stampDutyAmount: '',
    registrationNumber: '', registrationDate: '', registeredAt: '',
    witness1Name: '', witness1Phone: '', witness1Address: '',
    witness2Name: '', witness2Phone: '', witness2Address: '',
    terminationClause: '', specialConditions: '', status: 'Pending',
};

// ============================================================
// HELPER FUNCTIONS
// ============================================================
const formatCurrency = (amount) => {
    const num = Number(amount);
    if (!num) return '₹0';
    return `₹${num.toLocaleString('en-IN')}`;
};

const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};

const getStatusColor = (status) => {
    switch (status) {
        case 'Active': return 'bg-green-100 text-green-700 border-green-200';
        case 'Expired': return 'bg-red-100 text-red-700 border-red-200';
        case 'Pending': return 'bg-yellow-100 text-yellow-700 border-yellow-200';
        case 'Terminated': return 'bg-gray-100 text-gray-700 border-gray-200';
        case 'Under Renewal': return 'bg-blue-100 text-blue-700 border-blue-200';
        default: return 'bg-gray-100 text-gray-700 border-gray-200';
    }
};

const getPropertyIcon = (type) => {
    switch (type) {
        case 'Commercial Space':
        case 'Office Space':
            return <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />;
        case 'Retail/Showroom':
            return <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />;
        case 'Warehouse/Godown':
        case 'Industrial':
            return <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />;
        case 'Medical/Clinic':
            return <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />;
        case 'Educational Institution':
            return <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 14l9-5-9-5-9 5 9 5z M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />;
        case 'Hospitality/Resort':
            return <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />;
        case 'Agricultural Land':
            return <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />;
        default:
            return <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />;
    }
};

// ============================================================
// MAIN COMPONENT
// ============================================================
export default function LeaseAgreementPage() {
    const [agreements, setAgreements] = useState(mockLeaseAgreements);
    const [filterStatus, setFilterStatus] = useState('All');
    const [searchTerm, setSearchTerm] = useState('');

    // Modal states
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedAgreement, setSelectedAgreement] = useState(null);
    const [formData, setFormData] = useState(emptyForm);
    const [formErrors, setFormErrors] = useState({});

    // Filtering
    const filteredAgreements = agreements.filter(a => {
        const matchesStatus = filterStatus === 'All' || a.status === filterStatus;
        const matchesSearch = searchTerm === '' ||
            a.lesseeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            a.lessorName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            a.propertyAddress.toLowerCase().includes(searchTerm.toLowerCase()) ||
            a.id.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesStatus && matchesSearch;
    });

    // Counts
    const statusCounts = {
        All: agreements.length,
        Active: agreements.filter(a => a.status === 'Active').length,
        Expired: agreements.filter(a => a.status === 'Expired').length,
        Pending: agreements.filter(a => a.status === 'Pending').length,
        Terminated: agreements.filter(a => a.status === 'Terminated').length,
        'Under Renewal': agreements.filter(a => a.status === 'Under Renewal').length,
    };

    // Form handlers
    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (formErrors[name]) setFormErrors(prev => ({ ...prev, [name]: '' }));

        // Auto-calculate monthly rent from annual rent
        if (name === 'annualRent' && value) {
            const monthly = Math.round(Number(value) / 12);
            setFormData(prev => ({ ...prev, annualRent: value, monthlyRent: String(monthly) }));
        }
        // Auto-calculate annual rent from monthly rent
        if (name === 'monthlyRent' && value) {
            const annual = Number(value) * 12;
            setFormData(prev => ({ ...prev, monthlyRent: value, annualRent: String(annual) }));
        }
    };

    const validateForm = () => {
        const errors = {};
        if (!formData.lessorName.trim()) errors.lessorName = 'Required';
        if (!formData.lessorPhone.trim()) errors.lessorPhone = 'Required';
        if (!formData.lessorAddress.trim()) errors.lessorAddress = 'Required';
        if (!formData.lesseeName.trim()) errors.lesseeName = 'Required';
        if (!formData.lesseePhone.trim()) errors.lesseePhone = 'Required';
        if (!formData.lesseeAddress.trim()) errors.lesseeAddress = 'Required';
        if (!formData.lesseeIdProofNumber.trim()) errors.lesseeIdProofNumber = 'Required';
        if (!formData.propertyAddress.trim()) errors.propertyAddress = 'Required';
        if (!formData.propertyArea.trim()) errors.propertyArea = 'Required';
        if (!formData.leaseDurationYears.trim()) errors.leaseDurationYears = 'Required';
        if (!formData.leaseStartDate) errors.leaseStartDate = 'Required';
        if (!formData.leaseEndDate) errors.leaseEndDate = 'Required';
        if (!formData.annualRent.trim()) errors.annualRent = 'Required';
        if (!formData.securityDeposit.trim()) errors.securityDeposit = 'Required';
        return errors;
    };

    const handleAddNew = () => {
        setFormData(emptyForm);
        setFormErrors({});
        setIsEditMode(false);
        setIsAddModalOpen(true);
    };

    const handleCardClick = (agreement) => {
        setSelectedAgreement(agreement);
        setIsViewModalOpen(true);
        setIsEditMode(false);
    };

    const handleEditFromView = () => {
        setFormData({ ...selectedAgreement });
        setFormErrors({});
        setIsEditMode(true);
        setIsViewModalOpen(false);
        setIsAddModalOpen(true);
    };

    const handleFormSubmit = () => {
        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        if (isEditMode && selectedAgreement) {
            setAgreements(prev => prev.map(a =>
                a.id === selectedAgreement.id ? { ...a, ...formData } : a
            ));
        } else {
            const newAgreement = {
                ...formData,
                id: `LA-${String(agreements.length + 1).padStart(3, '0')}`,
                createdAt: new Date().toISOString().split('T')[0],
            };
            setAgreements(prev => [newAgreement, ...prev]);
        }

        setIsAddModalOpen(false);
        setFormData(emptyForm);
        setFormErrors({});
        setSelectedAgreement(null);
        setIsEditMode(false);
    };

    const handlePrint = () => {
        window.print();
    };

    const closeAllModals = () => {
        setIsAddModalOpen(false);
        setIsViewModalOpen(false);
        setIsEditMode(false);
        setSelectedAgreement(null);
        setFormData(emptyForm);
        setFormErrors({});
    };

    // Input class helper
    const inputCls = (field) =>
        `w-full px-3 py-2.5 border rounded-lg text-sm outline-none transition-colors ${formErrors[field]
            ? 'border-red-400 focus:border-red-500 focus:ring-1 focus:ring-red-200'
            : 'border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-200'
        }`;

    return (
        <>
            <Navbar />
            <main className="min-h-screen bg-gray-50">

                {/* ─── Header ─── */}
                <section className="bg-white border-b border-gray-200 py-3">
                    <div className="container-custom py-6">
                        {/* Breadcrumb */}
                        <nav className="flex items-center gap-2 text-sm text-gray-500 mb-4">
                            <Link href="/" className="hover:text-primary transition-colors">Home</Link>
                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                            <span className="text-gray-900 font-medium">Lease Agreements</span>
                        </nav>

                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                            <div>
                                <h1 className="text-2xl lg:text-3xl font-bold text-gray-900">Lease Agreements</h1>
                                <p className="text-gray-500 mt-1">Manage all your long-term lease agreements in one place</p>
                            </div>
                            <button
                                onClick={handleAddNew}
                                className="btn bg-green-600 hover:bg-green-700 text-white self-start flex items-center gap-2 px-5 py-2.5 rounded-lg font-medium transition-colors shadow-sm"
                            >
                                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                </svg>
                                New Lease Agreement
                            </button>
                        </div>
                    </div>
                </section>

                {/* ─── Filters & Search ─── */}
                <div className="container-custom py-6">
                    <div className="flex flex-col md:flex-row gap-4 mb-6 mt-5">
                        {/* Status Filter Chips */}
                        <div className="flex gap-2 flex-wrap">
                            {['All', 'Active', 'Pending', 'Expired', 'Terminated', 'Under Renewal'].map(s => (
                                <button
                                    key={s}
                                    onClick={() => setFilterStatus(s)}
                                    className={`px-4 py-1 rounded-full text-sm font-medium transition-colors border ${filterStatus === s
                                        ? 'bg-blue-600 text-white border-blue-600'
                                        : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-100'
                                        }`}
                                >
                                    {s} ({statusCounts[s] || 0})
                                </button>
                            ))}
                        </div>

                        {/* Search */}
                        <div className="relative md:ml-auto md:min-w-[300px]">
                            <svg className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            <input
                                type="text"
                                placeholder="Search by lessor, lessee, property, ID..."
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-colors"
                            />
                        </div>
                    </div>

                    {/* ─── Lease Agreement Cards Grid ─── */}
                    {filteredAgreements.length > 0 ? (
                        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                            {filteredAgreements.map((agreement) => (
                                <div
                                    key={agreement.id}
                                    onClick={() => handleCardClick(agreement)}
                                    className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-lg transition-all cursor-pointer group"
                                >
                                    {/* Card Header */}
                                    <div className="bg-[#6e6e6e] px-5 py-4 flex items-center justify-between">
                                        <div className="flex items-center gap-3">
                                            <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm">
                                                <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    {getPropertyIcon(agreement.propertyType)}
                                                </svg>
                                            </div>
                                            <div>
                                                <p className="text-white/80 text-xs">{agreement.id}</p>
                                                <p className="text-white font-semibold text-sm">{agreement.propertyType}</p>
                                            </div>
                                        </div>
                                        <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border ${getStatusColor(agreement.status)}`}>
                                            {agreement.status}
                                        </span>
                                    </div>

                                    {/* Card Body */}
                                    <div className="px-5 py-4">
                                        {/* Rent & Duration */}
                                        <div className="mb-3">
                                            <p className="text-2xl font-bold text-gray-900">{formatCurrency(agreement.monthlyRent)}<span className="text-sm font-normal text-gray-500">/mo</span></p>
                                            <p className="text-xs text-gray-500">{agreement.leaseDurationYears} Year Lease • {agreement.escalationRate}% Escalation</p>
                                        </div>

                                        {/* Lessor & Lessee */}
                                        <div className="space-y-2 mb-4">
                                            <div className="flex items-center gap-2">
                                                <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                                                    <svg className="w-3.5 h-3.5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                    </svg>
                                                </div>
                                                <div className="text-sm overflow-hidden">
                                                    <span className="text-gray-500">Lessor: </span>
                                                    <span className="font-medium text-gray-900 truncate">{agreement.lessorName}</span>
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-2">
                                                <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0">
                                                    <svg className="w-3.5 h-3.5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                    </svg>
                                                </div>
                                                <div className="text-sm overflow-hidden">
                                                    <span className="text-gray-500">Lessee: </span>
                                                    <span className="font-medium text-gray-900 truncate">{agreement.lesseeName}</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Property Address */}
                                        <p className="text-xs text-gray-500 line-clamp-2 mb-3">
                                            <svg className="w-3.5 h-3.5 inline mr-1 -mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                            </svg>
                                            {agreement.propertyAddress}
                                        </p>

                                        {/* Duration */}
                                        <div className="flex items-center justify-between text-xs text-gray-500 pt-3 border-t border-gray-100">
                                            <span>{formatDate(agreement.leaseStartDate)}</span>
                                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                            </svg>
                                            <span>{formatDate(agreement.leaseEndDate)}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="py-16 text-center bg-white rounded-xl border border-gray-200">
                            <svg className="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            <p className="text-gray-500 text-lg font-medium">No lease agreements found</p>
                            <p className="text-gray-400 text-sm mt-1">Try adjusting your filters or create a new lease agreement</p>
                        </div>
                    )}
                </div>
            </main>
            <Footer />

            {/* ═══════════════════════════════════════════════════
                VIEW DETAILS MODAL
            ═══════════════════════════════════════════════════ */}
            {isViewModalOpen && selectedAgreement && (
                <div className="fixed inset-0 z-50 overflow-y-auto">
                    <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={() => { setIsViewModalOpen(false); setSelectedAgreement(null); }}></div>
                    <div className="flex min-h-full items-center justify-center p-4">
                        <div className="relative bg-white rounded-xl shadow-2xl max-w-3xl w-full max-h-[90vh] flex flex-col transform transition-all">

                            {/* Header */}
                            <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200 flex-shrink-0 bg-gradient-to-r from-indigo-600 to-indigo-700 rounded-t-xl">
                                <div>
                                    <p className="text-indigo-100 text-sm">{selectedAgreement.id}</p>
                                    <h2 className="text-xl font-bold text-white">Lease Agreement Details</h2>
                                </div>
                                <div className="flex items-center gap-2">

                                    <button
                                        onClick={handlePrint}
                                        className="flex items-center gap-2 px-3 py-1 text-sm bg-gray-100 rounded hover:bg-gray-200 transition-colors"
                                    >
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2V5a2 2 0 00-2-2H6a2 2 0 00-2 2v10a2 2 0 002 2h2m4 0v2m0-2h.01M7 16h10" />
                                        </svg>
                                        Print
                                    </button>
                                    <button
                                        onClick={handleEditFromView}
                                        className="p-2 text-white/80 hover:text-white hover:bg-white/20 rounded-lg transition-colors"
                                        title="Edit Agreement"
                                    >
                                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                        </svg>
                                    </button>
                                    <button
                                        onClick={() => { setIsViewModalOpen(false); setSelectedAgreement(null); }}
                                        className="p-2 text-white/80 hover:text-white hover:bg-white/20 rounded-lg transition-colors"
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            {/* Body */}
                            <div className="overflow-y-auto flex-1 px-6 py-5 space-y-6">

                                {/* Status & Property Type */}
                                <div className="flex items-center gap-3 flex-wrap">
                                    <span className={`text-sm font-semibold px-3 py-1.5 rounded-full border ${getStatusColor(selectedAgreement.status)}`}>
                                        {selectedAgreement.status}
                                    </span>
                                    <span className="text-sm font-medium text-gray-600 bg-gray-100 px-3 py-1.5 rounded-full">
                                        {selectedAgreement.propertyType} — {selectedAgreement.propertyArea} sq.ft
                                    </span>
                                    <span className="text-sm font-medium text-indigo-600 bg-indigo-50 px-3 py-1.5 rounded-full">
                                        {selectedAgreement.leaseDurationYears} Year Lease
                                    </span>
                                    <span className="text-sm text-gray-500">Created: {formatDate(selectedAgreement.createdAt)}</span>
                                </div>

                                {/* Financial Summary */}
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                    <div className="bg-green-50 rounded-lg p-4 text-center border border-green-100">
                                        <p className="text-xs text-green-600 font-medium mb-1">Monthly Rent</p>
                                        <p className="text-lg font-bold text-green-700">{formatCurrency(selectedAgreement.monthlyRent)}</p>
                                    </div>
                                    <div className="bg-blue-50 rounded-lg p-4 text-center border border-blue-100">
                                        <p className="text-xs text-blue-600 font-medium mb-1">Annual Rent</p>
                                        <p className="text-lg font-bold text-blue-700">{formatCurrency(selectedAgreement.annualRent)}</p>
                                    </div>
                                    <div className="bg-purple-50 rounded-lg p-4 text-center border border-purple-100">
                                        <p className="text-xs text-purple-600 font-medium mb-1">Advance Amount</p>
                                        <p className="text-lg font-bold text-purple-700">{formatCurrency(selectedAgreement.advanceAmount)}</p>
                                    </div>
                                    <div className="bg-orange-50 rounded-lg p-4 text-center border border-orange-100">
                                        <p className="text-xs text-orange-600 font-medium mb-1">Security Deposit</p>
                                        <p className="text-lg font-bold text-orange-700">{formatCurrency(selectedAgreement.securityDeposit)}</p>
                                    </div>
                                </div>

                                {/* Lessor Details */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3 flex items-center gap-2">
                                        <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center">
                                            <svg className="w-3.5 h-3.5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                        </div>
                                        Lessor Details
                                    </h3>
                                    <div className="bg-gray-50 rounded-lg p-4 grid grid-cols-2 gap-3 text-sm">
                                        <div><span className="text-gray-500">Name:</span> <span className="font-medium text-gray-900">{selectedAgreement.lessorName}</span></div>
                                        <div><span className="text-gray-500">Phone:</span> <span className="font-medium text-gray-900">{selectedAgreement.lessorPhone}</span></div>
                                        <div><span className="text-gray-500">Email:</span> <span className="font-medium text-gray-900">{selectedAgreement.lessorEmail || '—'}</span></div>
                                        <div><span className="text-gray-500">PAN:</span> <span className="font-medium text-gray-900">{selectedAgreement.lessorPAN || '—'}</span></div>
                                        <div className="col-span-2"><span className="text-gray-500">Address:</span> <span className="font-medium text-gray-900">{selectedAgreement.lessorAddress}</span></div>
                                    </div>
                                </div>

                                {/* Lessee Details */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3 flex items-center gap-2">
                                        <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center">
                                            <svg className="w-3.5 h-3.5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                        </div>
                                        Lessee Details
                                    </h3>
                                    <div className="bg-gray-50 rounded-lg p-4 grid grid-cols-2 gap-3 text-sm">
                                        <div><span className="text-gray-500">Name:</span> <span className="font-medium text-gray-900">{selectedAgreement.lesseeName}</span></div>
                                        <div><span className="text-gray-500">Phone:</span> <span className="font-medium text-gray-900">{selectedAgreement.lesseePhone}</span></div>
                                        <div><span className="text-gray-500">Email:</span> <span className="font-medium text-gray-900">{selectedAgreement.lesseeEmail || '—'}</span></div>
                                        <div><span className="text-gray-500">PAN:</span> <span className="font-medium text-gray-900">{selectedAgreement.lesseePAN || '—'}</span></div>
                                        <div><span className="text-gray-500">ID Proof:</span> <span className="font-medium text-gray-900">{selectedAgreement.lesseeIdProofType} — {selectedAgreement.lesseeIdProofNumber}</span></div>
                                        <div className="col-span-2"><span className="text-gray-500">Address:</span> <span className="font-medium text-gray-900">{selectedAgreement.lesseeAddress}</span></div>
                                    </div>
                                </div>

                                {/* Property Details */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3 flex items-center gap-2">
                                        <div className="w-6 h-6 rounded-full bg-orange-100 flex items-center justify-center">
                                            <svg className="w-3.5 h-3.5 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
                                        </div>
                                        Property Details
                                    </h3>
                                    <div className="bg-gray-50 rounded-lg p-4 text-sm space-y-2">
                                        <div><span className="text-gray-500">Address:</span> <span className="font-medium text-gray-900">{selectedAgreement.propertyAddress}</span></div>
                                        <div className="grid grid-cols-3 gap-3">
                                            <div><span className="text-gray-500">Type:</span> <span className="font-medium text-gray-900">{selectedAgreement.propertyType}</span></div>
                                            <div><span className="text-gray-500">Area:</span> <span className="font-medium text-gray-900">{selectedAgreement.propertyArea} sq.ft</span></div>
                                            <div><span className="text-gray-500">Survey No:</span> <span className="font-medium text-gray-900">{selectedAgreement.surveyNumber || '—'}</span></div>
                                        </div>
                                        <div className="grid grid-cols-2 gap-3">
                                            <div><span className="text-gray-500">Permitted Use:</span> <span className="font-medium text-gray-900">{selectedAgreement.permittedUse || '—'}</span></div>
                                            <div><span className="text-gray-500">Subletting:</span> <span className="font-medium text-gray-900">{selectedAgreement.sublettingAllowed}</span></div>
                                        </div>
                                    </div>
                                </div>

                                {/* Lease Terms */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3 flex items-center gap-2">
                                        <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center">
                                            <svg className="w-3.5 h-3.5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                                        </div>
                                        Lease Terms
                                    </h3>
                                    <div className="bg-gray-50 rounded-lg p-4 grid grid-cols-2 gap-3 text-sm">
                                        <div><span className="text-gray-500">Lease Duration:</span> <span className="font-medium text-gray-900">{selectedAgreement.leaseDurationYears} Years</span></div>
                                        <div><span className="text-gray-500">Start Date:</span> <span className="font-medium text-gray-900">{formatDate(selectedAgreement.leaseStartDate)}</span></div>
                                        <div><span className="text-gray-500">End Date:</span> <span className="font-medium text-gray-900">{formatDate(selectedAgreement.leaseEndDate)}</span></div>
                                        <div><span className="text-gray-500">Payment Due:</span> <span className="font-medium text-gray-900">{selectedAgreement.rentPaymentDueDate ? `${selectedAgreement.rentPaymentDueDate}th of every month` : '—'}</span></div>
                                        <div><span className="text-gray-500">Escalation Rate:</span> <span className="font-medium text-gray-900">{selectedAgreement.escalationRate}%</span></div>
                                        <div><span className="text-gray-500">Escalation Frequency:</span> <span className="font-medium text-gray-900">{selectedAgreement.escalationFrequency}</span></div>
                                        <div className="col-span-2"><span className="text-gray-500">Renewal Option:</span> <span className="font-medium text-gray-900">{selectedAgreement.renewalOption || '—'}</span></div>
                                    </div>
                                </div>

                                {/* Registration & Stamp Duty */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3 flex items-center gap-2">
                                        <div className="w-6 h-6 rounded-full bg-teal-100 flex items-center justify-center">
                                            <svg className="w-3.5 h-3.5 text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
                                        </div>
                                        Registration & Stamp Duty
                                    </h3>
                                    <div className="bg-gray-50 rounded-lg p-4 grid grid-cols-2 gap-3 text-sm">
                                        <div><span className="text-gray-500">Reg. Number:</span> <span className="font-medium text-gray-900">{selectedAgreement.registrationNumber || '—'}</span></div>
                                        <div><span className="text-gray-500">Reg. Date:</span> <span className="font-medium text-gray-900">{formatDate(selectedAgreement.registrationDate)}</span></div>
                                        <div><span className="text-gray-500">Registered At:</span> <span className="font-medium text-gray-900">{selectedAgreement.registeredAt || '—'}</span></div>
                                        <div><span className="text-gray-500">Stamp Duty:</span> <span className="font-medium text-gray-900">{formatCurrency(selectedAgreement.stampDutyAmount)}</span></div>
                                        <div><span className="text-gray-500">Stamp Duty Paid By:</span> <span className="font-medium text-gray-900">{selectedAgreement.stampDutyPaidBy}</span></div>
                                    </div>
                                </div>

                                {/* Witnesses */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3 flex items-center gap-2">
                                        <div className="w-6 h-6 rounded-full bg-yellow-100 flex items-center justify-center">
                                            <svg className="w-3.5 h-3.5 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                                        </div>
                                        Witnesses
                                    </h3>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="bg-gray-50 rounded-lg p-4 text-sm space-y-1">
                                            <p className="font-semibold text-gray-700 mb-2">Witness 1</p>
                                            <div><span className="text-gray-500">Name:</span> <span className="font-medium text-gray-900">{selectedAgreement.witness1Name || '—'}</span></div>
                                            <div><span className="text-gray-500">Phone:</span> <span className="font-medium text-gray-900">{selectedAgreement.witness1Phone || '—'}</span></div>
                                            <div><span className="text-gray-500">Address:</span> <span className="font-medium text-gray-900">{selectedAgreement.witness1Address || '—'}</span></div>
                                        </div>
                                        <div className="bg-gray-50 rounded-lg p-4 text-sm space-y-1">
                                            <p className="font-semibold text-gray-700 mb-2">Witness 2</p>
                                            <div><span className="text-gray-500">Name:</span> <span className="font-medium text-gray-900">{selectedAgreement.witness2Name || '—'}</span></div>
                                            <div><span className="text-gray-500">Phone:</span> <span className="font-medium text-gray-900">{selectedAgreement.witness2Phone || '—'}</span></div>
                                            <div><span className="text-gray-500">Address:</span> <span className="font-medium text-gray-900">{selectedAgreement.witness2Address || '—'}</span></div>
                                        </div>
                                    </div>
                                </div>

                                {/* Termination Clause */}
                                {selectedAgreement.terminationClause && (
                                    <div>
                                        <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">Termination Clause</h3>
                                        <p className="text-sm text-gray-600 bg-red-50 rounded-lg p-4 leading-relaxed border border-red-100">{selectedAgreement.terminationClause}</p>
                                    </div>
                                )}

                                {/* Special Conditions */}
                                {selectedAgreement.specialConditions && (
                                    <div>
                                        <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">Special Conditions</h3>
                                        <p className="text-sm text-gray-600 bg-gray-50 rounded-lg p-4 leading-relaxed">{selectedAgreement.specialConditions}</p>
                                    </div>
                                )}
                            </div>

                            {/* Footer */}
                            <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-200 flex-shrink-0">
                                <button
                                    onClick={() => { setIsViewModalOpen(false); setSelectedAgreement(null); }}
                                    className="px-5 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                                >
                                    Close
                                </button>
                                <button
                                    onClick={handleEditFromView}
                                    className="px-5 py-2.5 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors flex items-center gap-2"
                                >
                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                    Edit Lease
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ═══════════════════════════════════════════════════
                ADD / EDIT FORM MODAL
            ═══════════════════════════════════════════════════ */}
            {isAddModalOpen && (
                <div className="fixed inset-0 z-50 overflow-y-auto">
                    <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={closeAllModals}></div>
                    <div className="flex min-h-full items-center justify-center p-4">
                        <div className="relative bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] flex flex-col transform transition-all">

                            {/* Header */}
                            <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200 flex-shrink-0">
                                <div className="flex items-center gap-3">
                                    <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${isEditMode ? 'bg-indigo-100' : 'bg-green-100'}`}>
                                        {isEditMode ? (
                                            <svg className="w-5 h-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
                                        ) : (
                                            <svg className="w-5 h-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                                        )}
                                    </div>
                                    <h2 className="text-xl font-bold text-gray-900">
                                        {isEditMode ? 'Edit Lease Agreement' : 'New Lease Agreement'}
                                    </h2>
                                </div>
                                <button onClick={closeAllModals} className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-lg hover:bg-gray-100">
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                                </button>
                            </div>

                            {/* Scrollable Body */}
                            <div className="overflow-y-auto flex-1 px-6 py-5 space-y-6">

                                {/* ── Lessor Details ── */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4 flex items-center gap-2">
                                        <svg className="w-4 h-4 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                        Lessor (Property Owner) Details
                                    </h3>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Lessor Name <span className="text-red-500">*</span></label>
                                            <input type="text" name="lessorName" value={formData.lessorName} onChange={handleFormChange} placeholder="Enter lessor / company name" className={inputCls('lessorName')} />
                                            {formErrors.lessorName && <p className="mt-1 text-xs text-red-600">{formErrors.lessorName}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Lessor Phone <span className="text-red-500">*</span></label>
                                            <input type="tel" name="lessorPhone" value={formData.lessorPhone} onChange={handleFormChange} placeholder="Enter phone number" maxLength={10} className={inputCls('lessorPhone')} />
                                            {formErrors.lessorPhone && <p className="mt-1 text-xs text-red-600">{formErrors.lessorPhone}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Lessor Email</label>
                                            <input type="email" name="lessorEmail" value={formData.lessorEmail} onChange={handleFormChange} placeholder="Enter email" className={inputCls('lessorEmail')} />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Lessor PAN</label>
                                            <input type="text" name="lessorPAN" value={formData.lessorPAN} onChange={handleFormChange} placeholder="e.g. AABCM1234F" maxLength={10} className={inputCls('lessorPAN')} />
                                        </div>
                                        <div className="md:col-span-2">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Lessor Address <span className="text-red-500">*</span></label>
                                            <textarea name="lessorAddress" value={formData.lessorAddress} onChange={handleFormChange} placeholder="Enter lessor address" rows="2" className={inputCls('lessorAddress')}></textarea>
                                            {formErrors.lessorAddress && <p className="mt-1 text-xs text-red-600">{formErrors.lessorAddress}</p>}
                                        </div>
                                    </div>
                                </div>

                                {/* ── Lessee Details ── */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4 flex items-center gap-2">
                                        <svg className="w-4 h-4 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                        Lessee (Tenant) Details
                                    </h3>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Lessee Name <span className="text-red-500">*</span></label>
                                            <input type="text" name="lesseeName" value={formData.lesseeName} onChange={handleFormChange} placeholder="Enter lessee / company name" className={inputCls('lesseeName')} />
                                            {formErrors.lesseeName && <p className="mt-1 text-xs text-red-600">{formErrors.lesseeName}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Lessee Phone <span className="text-red-500">*</span></label>
                                            <input type="tel" name="lesseePhone" value={formData.lesseePhone} onChange={handleFormChange} placeholder="Enter phone number" maxLength={10} className={inputCls('lesseePhone')} />
                                            {formErrors.lesseePhone && <p className="mt-1 text-xs text-red-600">{formErrors.lesseePhone}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Lessee Email</label>
                                            <input type="email" name="lesseeEmail" value={formData.lesseeEmail} onChange={handleFormChange} placeholder="Enter email" className={inputCls('lesseeEmail')} />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Lessee PAN</label>
                                            <input type="text" name="lesseePAN" value={formData.lesseePAN} onChange={handleFormChange} placeholder="e.g. AABFT5678G" maxLength={10} className={inputCls('lesseePAN')} />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">ID Proof Type</label>
                                            <select name="lesseeIdProofType" value={formData.lesseeIdProofType} onChange={handleFormChange} className={inputCls('lesseeIdProofType')}>
                                                {idProofTypes.map(t => <option key={t} value={t}>{t}</option>)}
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">ID Proof Number <span className="text-red-500">*</span></label>
                                            <input type="text" name="lesseeIdProofNumber" value={formData.lesseeIdProofNumber} onChange={handleFormChange} placeholder="Enter ID proof / registration number" className={inputCls('lesseeIdProofNumber')} />
                                            {formErrors.lesseeIdProofNumber && <p className="mt-1 text-xs text-red-600">{formErrors.lesseeIdProofNumber}</p>}
                                        </div>
                                        <div className="md:col-span-2">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Lessee Address <span className="text-red-500">*</span></label>
                                            <textarea name="lesseeAddress" value={formData.lesseeAddress} onChange={handleFormChange} placeholder="Enter lessee address" rows="2" className={inputCls('lesseeAddress')}></textarea>
                                            {formErrors.lesseeAddress && <p className="mt-1 text-xs text-red-600">{formErrors.lesseeAddress}</p>}
                                        </div>
                                    </div>
                                </div>

                                {/* ── Property Details ── */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4 flex items-center gap-2">
                                        <svg className="w-4 h-4 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
                                        Property Details
                                    </h3>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="md:col-span-2">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Property Address <span className="text-red-500">*</span></label>
                                            <textarea name="propertyAddress" value={formData.propertyAddress} onChange={handleFormChange} placeholder="Enter complete property address" rows="2" className={inputCls('propertyAddress')}></textarea>
                                            {formErrors.propertyAddress && <p className="mt-1 text-xs text-red-600">{formErrors.propertyAddress}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Property Type</label>
                                            <select name="propertyType" value={formData.propertyType} onChange={handleFormChange} className={inputCls('propertyType')}>
                                                {propertyTypes.map(t => <option key={t} value={t}>{t}</option>)}
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Area (sq.ft) <span className="text-red-500">*</span></label>
                                            <input type="number" name="propertyArea" value={formData.propertyArea} onChange={handleFormChange} placeholder="e.g. 3500" className={inputCls('propertyArea')} />
                                            {formErrors.propertyArea && <p className="mt-1 text-xs text-red-600">{formErrors.propertyArea}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Survey Number</label>
                                            <input type="text" name="surveyNumber" value={formData.surveyNumber} onChange={handleFormChange} placeholder="e.g. S.No. 45/2A" className={inputCls('surveyNumber')} />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Permitted Use</label>
                                            <input type="text" name="permittedUse" value={formData.permittedUse} onChange={handleFormChange} placeholder="e.g. IT Office / Retail / Warehouse" className={inputCls('permittedUse')} />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Subletting Allowed</label>
                                            <select name="sublettingAllowed" value={formData.sublettingAllowed} onChange={handleFormChange} className={inputCls('sublettingAllowed')}>
                                                {sublettingOptions.map(t => <option key={t} value={t}>{t}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* ── Lease Duration & Terms ── */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4 flex items-center gap-2">
                                        <svg className="w-4 h-4 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                                        Lease Duration & Terms
                                    </h3>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Lease Duration (Years) <span className="text-red-500">*</span></label>
                                            <input type="number" name="leaseDurationYears" value={formData.leaseDurationYears} onChange={handleFormChange} placeholder="e.g. 5" className={inputCls('leaseDurationYears')} />
                                            {formErrors.leaseDurationYears && <p className="mt-1 text-xs text-red-600">{formErrors.leaseDurationYears}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Start Date <span className="text-red-500">*</span></label>
                                            <input type="date" name="leaseStartDate" value={formData.leaseStartDate} onChange={handleFormChange} className={inputCls('leaseStartDate')} />
                                            {formErrors.leaseStartDate && <p className="mt-1 text-xs text-red-600">{formErrors.leaseStartDate}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">End Date <span className="text-red-500">*</span></label>
                                            <input type="date" name="leaseEndDate" value={formData.leaseEndDate} onChange={handleFormChange} className={inputCls('leaseEndDate')} />
                                            {formErrors.leaseEndDate && <p className="mt-1 text-xs text-red-600">{formErrors.leaseEndDate}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Escalation Rate (%)</label>
                                            <input type="number" name="escalationRate" value={formData.escalationRate} onChange={handleFormChange} placeholder="e.g. 10" className={inputCls('escalationRate')} />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Escalation Frequency</label>
                                            <select name="escalationFrequency" value={formData.escalationFrequency} onChange={handleFormChange} className={inputCls('escalationFrequency')}>
                                                {escalationFrequencies.map(t => <option key={t} value={t}>{t}</option>)}
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Payment Due Date (day)</label>
                                            <input type="number" name="rentPaymentDueDate" value={formData.rentPaymentDueDate} onChange={handleFormChange} placeholder="e.g. 5" min="1" max="31" className={inputCls('rentPaymentDueDate')} />
                                        </div>
                                        <div className="md:col-span-3">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Renewal Option</label>
                                            <input type="text" name="renewalOption" value={formData.renewalOption} onChange={handleFormChange} placeholder="e.g. Renewable for additional 5 years with mutual consent" className={inputCls('renewalOption')} />
                                        </div>
                                    </div>
                                </div>

                                {/* ── Financials ── */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4 flex items-center gap-2">
                                        <svg className="w-4 h-4 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                                        Rent & Financial Details
                                    </h3>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Annual Rent (₹) <span className="text-red-500">*</span></label>
                                            <input type="number" name="annualRent" value={formData.annualRent} onChange={handleFormChange} placeholder="e.g. 1800000" className={inputCls('annualRent')} />
                                            {formErrors.annualRent && <p className="mt-1 text-xs text-red-600">{formErrors.annualRent}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Monthly Rent (₹) <span className="text-gray-400 text-xs">(auto-calculated)</span></label>
                                            <input type="number" name="monthlyRent" value={formData.monthlyRent} onChange={handleFormChange} placeholder="Auto-calculated from annual" className={inputCls('monthlyRent')} />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Advance Amount (₹)</label>
                                            <input type="number" name="advanceAmount" value={formData.advanceAmount} onChange={handleFormChange} placeholder="e.g. 1500000" className={inputCls('advanceAmount')} />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Security Deposit (₹) <span className="text-red-500">*</span></label>
                                            <input type="number" name="securityDeposit" value={formData.securityDeposit} onChange={handleFormChange} placeholder="e.g. 900000" className={inputCls('securityDeposit')} />
                                            {formErrors.securityDeposit && <p className="mt-1 text-xs text-red-600">{formErrors.securityDeposit}</p>}
                                        </div>
                                    </div>
                                </div>

                                {/* ── Registration & Stamp Duty ── */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4 flex items-center gap-2">
                                        <svg className="w-4 h-4 text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
                                        Registration & Stamp Duty
                                    </h3>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Registration Number</label>
                                            <input type="text" name="registrationNumber" value={formData.registrationNumber} onChange={handleFormChange} placeholder="e.g. REG/CHN/2024/04567" className={inputCls('registrationNumber')} />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Registration Date</label>
                                            <input type="date" name="registrationDate" value={formData.registrationDate} onChange={handleFormChange} className={inputCls('registrationDate')} />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Registered At</label>
                                            <input type="text" name="registeredAt" value={formData.registeredAt} onChange={handleFormChange} placeholder="Sub-Registrar Office name" className={inputCls('registeredAt')} />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Stamp Duty Amount (₹)</label>
                                            <input type="number" name="stampDutyAmount" value={formData.stampDutyAmount} onChange={handleFormChange} placeholder="e.g. 125000" className={inputCls('stampDutyAmount')} />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Stamp Duty Paid By</label>
                                            <select name="stampDutyPaidBy" value={formData.stampDutyPaidBy} onChange={handleFormChange} className={inputCls('stampDutyPaidBy')}>
                                                {stampDutyPaidByOptions.map(t => <option key={t} value={t}>{t}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* ── Witnesses ── */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4 flex items-center gap-2">
                                        <svg className="w-4 h-4 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                                        Witnesses
                                    </h3>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        {/* Witness 1 */}
                                        <div className="bg-gray-50 rounded-lg p-4 space-y-3">
                                            <p className="text-sm font-semibold text-gray-700">Witness 1</p>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                                <input type="text" name="witness1Name" value={formData.witness1Name} onChange={handleFormChange} placeholder="Witness name" className={inputCls('witness1Name')} />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                                                <input type="tel" name="witness1Phone" value={formData.witness1Phone} onChange={handleFormChange} placeholder="Phone number" maxLength={10} className={inputCls('witness1Phone')} />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
                                                <input type="text" name="witness1Address" value={formData.witness1Address} onChange={handleFormChange} placeholder="Address" className={inputCls('witness1Address')} />
                                            </div>
                                        </div>
                                        {/* Witness 2 */}
                                        <div className="bg-gray-50 rounded-lg p-4 space-y-3">
                                            <p className="text-sm font-semibold text-gray-700">Witness 2</p>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                                <input type="text" name="witness2Name" value={formData.witness2Name} onChange={handleFormChange} placeholder="Witness name" className={inputCls('witness2Name')} />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                                                <input type="tel" name="witness2Phone" value={formData.witness2Phone} onChange={handleFormChange} placeholder="Phone number" maxLength={10} className={inputCls('witness2Phone')} />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
                                                <input type="text" name="witness2Address" value={formData.witness2Address} onChange={handleFormChange} placeholder="Address" className={inputCls('witness2Address')} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ── Clauses & Conditions ── */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4 flex items-center gap-2">
                                        <svg className="w-4 h-4 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                                        Clauses & Conditions
                                    </h3>
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Termination Clause</label>
                                            <textarea name="terminationClause" value={formData.terminationClause} onChange={handleFormChange} placeholder="Describe lock-in period, notice requirements, penalties for early termination..." rows="3" className={inputCls('terminationClause')}></textarea>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Special Conditions</label>
                                            <textarea name="specialConditions" value={formData.specialConditions} onChange={handleFormChange} placeholder="Enter any special conditions, restrictions, or additional clauses..." rows="3" className={inputCls('specialConditions')}></textarea>
                                        </div>
                                        {isEditMode && (
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                                                <select name="status" value={formData.status} onChange={handleFormChange} className={inputCls('status')}>
                                                    {statusOptions.map(s => <option key={s} value={s}>{s}</option>)}
                                                </select>
                                            </div>
                                        )}
                                    </div>
                                </div>

                            </div>

                            {/* Footer */}
                            <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-200 flex-shrink-0">
                                <button
                                    onClick={closeAllModals}
                                    className="px-5 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleFormSubmit}
                                    className={`px-5 py-2.5 text-sm font-medium text-white rounded-lg transition-colors flex items-center gap-2 ${isEditMode ? 'bg-indigo-600 hover:bg-indigo-700' : 'bg-green-600 hover:bg-green-700'}`}
                                >
                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    {isEditMode ? 'Update Lease' : 'Create Lease Agreement'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ═══════════════════════════════════════════════════
                PRINTABLE LEASE AGREEMENT TEMPLATE (HIDDEN)
            ═══════════════════════════════════════════════════ */}
            {selectedAgreement && (
                <div id="printable-lease-agreement" className="hidden print:block font-serif text-gray-900 bg-white leading-relaxed text-justify p-0">
                    <style dangerouslySetInnerHTML={{
                        __html: `
                        @media print {
                            @page {
                                size: A4;
                                margin: 0;
                            }
                            body * {
                                visibility: hidden !important;
                            }
                            #printable-lease-agreement, #printable-lease-agreement * {
                                visibility: visible !important;
                            }
                            #printable-lease-agreement {
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 100%;
                                padding: 20mm;
                            }
                            .bond-header {
                                height: 95mm; /* Space for stamp paper */
                            }
                            .agreement-content {
                                font-size: 11pt;
                                line-height: 1.5;
                            }
                            .signature-box {
                                page-break-inside: avoid;
                            }
                            .page-break {
                                page-break-before: always;
                            }
                        }
                    `}} />

                    <div className="bond-header"></div>

                    <div className="agreement-content">
                        <h1 className="text-center text-2xl font-bold uppercase underline mb-10">Deed of Lease</h1>

                        <p className="mb-6">
                            This DEED OF LEASE is made and executed on this <strong>{new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}</strong> at Chennai,
                        </p>

                        <div className="mb-8">
                            <p className="font-bold mb-2 uppercase text-sm tracking-widest border-b border-gray-300 pb-1">BY AND BETWEEN:</p>
                            <p className="mb-4">
                                <strong>{selectedAgreement.lessorName}</strong>, 
                                {selectedAgreement.lessorPAN && <span> (PAN: {selectedAgreement.lessorPAN}), </span>}
                                residing at {selectedAgreement.lessorAddress},
                                hereinafter referred to as the <strong>"LESSOR"</strong> (which expression shall mean and include his heirs, executors, administrators, legal representatives and assigns) of the ONE PART.
                            </p>
                            <p className="text-center font-bold mb-4 italic">AND</p>
                            <p>
                                <strong>{selectedAgreement.lesseeName}</strong>, 
                                {selectedAgreement.lesseePAN && <span> (PAN: {selectedAgreement.lesseePAN}), </span>}
                                represented by its authorized signatory, residing at {selectedAgreement.lesseeAddress},
                                hereinafter referred to as the <strong>"LESSEE"</strong> (which expression shall mean and include its successors-in-interest and permitted assigns) of the OTHER PART.
                            </p>
                        </div>

                        <p className="mb-6">
                            <strong>WHEREAS</strong> the Lessor is the absolute owner of the property ( {selectedAgreement.propertyType} ) situated at <strong>{selectedAgreement.propertyAddress}</strong>, 
                            {selectedAgreement.surveyNumber && <span> comprised in {selectedAgreement.surveyNumber}, </span>}
                            measuring approximately <strong>{selectedAgreement.propertyArea} sq.ft.</strong>, hereinafter referred to as the "SCHEDULED PREMISES".
                        </p>

                        <p className="mb-6 italic underline font-semibold">NOW THIS DEED WITNESSETH AS UNDER:</p>

                        <ol className="list-decimal ml-8 space-y-4">
                            <li>
                                <strong>TERM:</strong> The lease shall be for a period of <strong>{selectedAgreement.leaseDurationYears} years</strong> 
                                commencing from <strong>{formatDate(selectedAgreement.leaseStartDate)}</strong> and ending on <strong>{formatDate(selectedAgreement.leaseEndDate)}</strong>.
                            </li>
                            <li>
                                <strong>RENT:</strong> The monthly lease rent is fixed at <strong>{formatCurrency(selectedAgreement.monthlyRent)}</strong> (Rupees {/* Words? */}). 
                                The rent shall be paid on or before the <strong>{selectedAgreement.rentPaymentDueDate || '5'}th</strong> of every month.
                            </li>
                            <li>
                                <strong>ESCALATION:</strong> The rent shall be subject to an escalation of <strong>{selectedAgreement.escalationRate}%</strong> 
                                on a <strong>{selectedAgreement.escalationFrequency}</strong> basis.
                            </li>
                            <li>
                                <strong>SECURITY DEPOSIT:</strong> The Lessee has paid an interest-free refundable security deposit of <strong>{formatCurrency(selectedAgreement.securityDeposit)}</strong> 
                                {selectedAgreement.advanceAmount && <span> and an advance of {formatCurrency(selectedAgreement.advanceAmount)} </span>} 
                                to the Lessor, the receipt of which the Lessor hereby acknowledges.
                            </li>
                            <li>
                                <strong>PURPOSE:</strong> The Scheduled Premises shall be used only for <strong>{selectedAgreement.permittedUse || 'Commercial'}</strong> purposes.
                            </li>
                            <li>
                                <strong>SUBLETTING:</strong> The Lessee {selectedAgreement.sublettingAllowed === 'No' ? 'shall NOT be permitted to sublet' : 'may sublet (as per terms)'} the premises.
                            </li>
                            <li>
                                <strong>TERMINATION:</strong> {selectedAgreement.terminationClause || 'As per standard laws.'}
                            </li>
                            {selectedAgreement.specialConditions && (
                                <li>
                                    <strong>SPECIAL CONDITIONS:</strong> {selectedAgreement.specialConditions}
                                </li>
                            )}
                        </ol>

                        <div className="mt-20 grid grid-cols-2 gap-20 signature-box">
                            <div className="text-center">
                                <p className="mb-16">For <strong>{selectedAgreement.lessorName}</strong></p>
                                <div className="border-t border-black pt-2 font-bold">LESSOR</div>
                            </div>
                            <div className="text-center">
                                <p className="mb-16">For <strong>{selectedAgreement.lesseeName}</strong></p>
                                <div className="border-t border-black pt-2 font-bold">LESSEE</div>
                            </div>
                        </div>

                        <div className="mt-20 signature-box">
                            <p className="font-bold mb-8 uppercase text-sm tracking-widest">WITNESSES:</p>
                            <div className="grid grid-cols-2 gap-10">
                                <div>
                                    <p className="font-bold mb-1">1. {selectedAgreement.witness1Name || '________________'}</p>
                                    <p className="text-xs text-gray-600 ml-4 italic">{selectedAgreement.witness1Address}</p>
                                </div>
                                <div>
                                    <p className="font-bold mb-1">2. {selectedAgreement.witness2Name || '________________'}</p>
                                    <p className="text-xs text-gray-600 ml-4 italic">{selectedAgreement.witness2Address}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
